import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/Vergissmeinnicht.jpg"


export const Vergissmeinnicht = () => {    

    return (
        <SongLinks 
        title={"Vergissmeinnicht"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/1jeBE5mTwUCfA4yzAA2s12?si=lgIiuaNCSxWQY5y0aia5Zw"}
        spotifyPresaveLink={undefined}
        appleMusicLink={"https://music.apple.com/de/album/vergissmeinnicht-single/1878237676"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/playlist?list=OLAK5uy_ltxvwMJ-JiHKD10jsL_FIy931DNz7UYqo&si=dQPMCg4n2GKE7BRr"}
        youtubeLink={"https://youtu.be/0mrQBthHNtA"}
        tidalLink={"https://tidal.com/album/500278951"}
        amazonMusicLink={"https://amazon.de/music/player/albums/B0GP58D6RN?marketplaceId=A1PA6795UKMFR9&musicTerritory=DE&ref=dm_sh_zYbD5rqcaAaQLrwqydt3qMVia"}
        bandcampLink={"https://mondwild.bandcamp.com/track/vergissmeinnicht"}
        releaseDate={"2026-03-13T00:00:00+01:00"}/>
    );
}